exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".example-sidenav {\n  padding: 20px;\n  border-radius: 1px;\n  border-right: 1px solid #f8f8f8; }\n\nmat-drawer p button {\n  max-width: 250px;\n  width: 200px; }\n\nmat-drawer-container {\n  height: 100%;\n  background-color: #F3F3F3; }\n\na.linkheader {\n  text-decoration: none; }\n\na.linkheader:visited {\n  color: #92FC92; }\n\na.linkheader:hover {\n  color: #d4f7d4; }\n\na img {\n  max-width: 80px;\n  max-height: 80px;\n  width: auto;\n  height: auto; }\n\nspan {\n  font-size: 12px;\n  font: Poppins;\n  color: #607D8B; }\n\na, h2 {\n  display: inline-block; }\n\na.linkheaderAdm:link {\n  text-decoration: none; }\n\na.linkheaderAcervo:link {\n  text-decoration: none; }\n\na.linkheaderAdm:active {\n  text-decoration: underline;\n  color: #92FC92; }\n\na.linkheaderAcervo:active {\n  text-decoration: underline;\n  color: #92FC92; }\n\na.linkheaderAdm:hover {\n  color: #92FC92; }\n\na.linkheaderAcervo:hover {\n  color: #92FC92; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/cliente-components/listaclientes/listaclientes.component.scss
// module id = ../../../../../src/app/components/cliente-components/listaclientes/listaclientes.component.scss
// module chunks = main